import type { FC } from 'react'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import useTranslate from '@/hooks/use-translate'
import {
  getCommandBarTriggerButtonSx,
  getCommandBarTriggerIconSlotSx,
  getCommandBarTriggerKeycapSx,
  getCommandBarTriggerLabelSx,
  getCommandBarTriggerTextSx,
} from './commandBarTrigger.styles'
import { useCommandBar } from './CommandBarProvider'
import { getCommandBarShortcutLabel } from './utils/getCommandBarShortcutLabel'

type CommandBarTriggerProps = {
  isFolded: boolean
  showText: boolean
}

/** Champ de recherche de la sidebar : il ne filtre rien lui-même, il ouvre la palette (TEC-1956). */
export const CommandBarTrigger: FC<CommandBarTriggerProps> = ({
  isFolded,
  showText,
}) => {
  const { t } = useTranslate('commandBar')
  const { openCommandBar } = useCommandBar()
  const shortcutLabel = getCommandBarShortcutLabel()
  const tooltipTitle = t('triggerTooltip', { shortcut: shortcutLabel })

  return (
    <Tooltip
      disableHoverListener={!isFolded}
      enterDelay={300}
      placement="right"
      title={tooltipTitle}
    >
      <ButtonBase
        onClick={openCommandBar}
        aria-label={tooltipTitle}
        data-testid="command-bar-trigger"
        sx={getCommandBarTriggerButtonSx(isFolded)}
      >
        <Box
          aria-hidden
          component="span"
          data-testid="command-bar-trigger-icon"
          sx={getCommandBarTriggerIconSlotSx()}
        />
        {!isFolded && (
          <Box component="span" sx={getCommandBarTriggerTextSx()}>
            <Typography
              component="span"
              sx={getCommandBarTriggerLabelSx(showText)}
            >
              {t('triggerPlaceholder')}
            </Typography>
            {showText ? (
              <Box
                component="kbd"
                data-testid="command-bar-trigger-shortcut"
                sx={getCommandBarTriggerKeycapSx()}
              >
                {shortcutLabel}
              </Box>
            ) : null}
          </Box>
        )}
      </ButtonBase>
    </Tooltip>
  )
}
